export const AdvertasingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <rect width="28" height="28" rx="14" fill="#F4F4F4" />
      <mask
        id="mask0_4433_599"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="4"
        y="4"
        width="20"
        height="20"
      >
        <rect x="4" y="4" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4433_599)">
        <path
          d="M8.5 21C8.0875 21 7.73437 20.8507 7.44062 20.5521C7.14687 20.2535 7 19.9028 7 19.5V8.5C7 8.09722 7.14687 7.74653 7.44062 7.44792C7.73437 7.14931 8.0875 7 8.5 7H19.5C19.9125 7 20.2656 7.14931 20.5594 7.44792C20.8531 7.74653 21 8.09722 21 8.5V19.5C21 19.9028 20.8531 20.2535 20.5594 20.5521C20.2656 20.8507 19.9125 21 19.5 21H8.5ZM8.5 19.5H19.5V11H8.5V19.5Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
};
